import { FC } from 'react';

import ModalWrap from '../../common/modal-wrap';

import { MacDeckSelectContent } from './mac-deck-select-content';

export interface IMacDeckSelectModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  sendMacCardsOpen?: (data: {
    show: boolean;
    cover: string;
    color: string;
    result: { name: string; value: string[] };
  }) => void;
}

export const MacDeckSelectModal: FC<IMacDeckSelectModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  sendMacCardsOpen,
}) => (
  <ModalWrap isShow={isOpen}>
    <div className="think-scroll flex max-h-[90vh] w-[min(560px,92vw)] flex-col rounded-[20px] bg-white shadow-shadowPopup overflow-hidden">
      <MacDeckSelectContent
        onClose={onClose}
        onConfirm={onConfirm}
        sendMacCardsOpen={sendMacCardsOpen}
        variant="modal"
      />
    </div>
  </ModalWrap>
);
